module.exports = __webpack_public_path__ + "img/wallet.3978da80.png";